module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "status has-header"
  }, [_c('banner'), _vm._v(" "), _c('user-bar'), _vm._v(" "), _c('div', {
    staticClass: "content-list"
  }, [_vm._l((_vm.items), function(item) {
    return _c('card', {
      key: item,
      attrs: {
        "mold": "quote"
      }
    })
  }), _vm._v(" "), _c('a', {
    staticClass: "list-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("显示更多广播")])], 2), _vm._v(" "), _c('download-app')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fecb78f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/StatusView.vue
// module id = 205
// module chunks = 0